export const SPECIAL = 'SPECIAL'; // 특가쿠폰
export const NORMAL = 'NORMAL'; // 쿠폰팝업 노출시 사용 하는 filter 값(일반 쿠폰)
export const SUPER = 'SUPER'; // 쿠폰팝업 노출시 사용 하는 filter 값(슈퍼 쿠폰)
export const SPECIAL_SUPER = 'SPECIAL_SUPER'; // 스폐셜 쿠폰에서 사용 하는 스폐셜슈퍼쿠폰

/**
 * 쿠폰의 타입이 Amount(정액)인지 확인
 */
export function isCouponTypeAmount(coupons) {
  const type = coupons.couponDisplaySummary.couponType;
  return type === 'AMOUNT' || type === 'CARTM';
}

/**
 * 쿠폰의 금액 반환
 */
export function getCouponValue(coupons) {
  let value = '';

  if (isCouponTypeAmount(coupons)) {
    value = `${TMON.util.numberFormat(
      coupons.couponDisplaySummary.discountAmount
    )}원`;
  } else {
    value = `${TMON.util.numberFormat(
      coupons.couponDisplaySummary.discountPercent
    )}%`;
  }

  return value;
}

/**
 * 이미 받은 쿠폰인지 확인
 */
export function verifyPublishCoupon(coupon) {
  return coupon.couponDisplaySummary.displayType === 'COMPLETION';
}

/**
 * couponsSummary api
 */
export function couponsSummaryFetchApi() {
  if (TMON.oApp && TMON.oApp.oApi) {
    TMON.oApp.oApi.fetchApi('couponsSummary', null, 'fetchApi');
  }
}

/**
 * coupons api
 */
export function couponsFetchApi() {
  if (TMON.oApp && TMON.oApp.oApi) {
    TMON.oApp.oApi.fetchApi('coupons', null, 'fetchApi');
  }
}

/**
 * issueCoupon api
 * 쿠폰 발급
 * @param {Number} couponSrl
 */
export function issueCouponFetchApi({ type, couponSrl }) {
  if (TMON.oApp && TMON.oApp.oApi) {
    TMON.oApp.oApi.fetchApi('issueCoupon', { couponSrl, type }, 'fetchApi');
  }
}

/**
 * coupon layer options 반환
 */
export function getCouponLayerOptions() {
  return {
    dealSrls: TMON.htStaticData.htDealInfo.dealNo,
  };
}

/**
 * 파트너 부담 쿠폰 적용 가능한 딜인지 확인
 * 옵션 딜 인 경우 파트너 쿠폰 노출하지 않음
 * @param {Object} coupon
 */
export function checkPartnerCoupon(coupon) {
  return (
    !TMON.oApp.oUtil.isEmpty(coupon) &&
    coupon.couponDisplaySummary.displayType !== 'NONE'
  );
}

/**
 * 스킴 텍스트로 랜더링할지 여부
 * 최소 금액 조건 부합하지 않음, 옵션딜, 즉시할인딜 경우 스킴 노출
 * @param {Object} coupon
 */
export function checkPartnerRenderSkim(coupon) {
  return (
    !checkPartnerCouponMinAmount(coupon) ||
    TMON.htStaticData.bOptionDeal ||
    !TMON.oApp.oUtil.isEmpty(
      TMON.htStaticData.htDealInfo.priceInfo.discountInfos.immediately
    )
  );
}

/**
 * 파트너 부담 쿠폰으로 노출될 가격 반환
 * 최소 금액 조건 부합하는 경우와 아닌 경우
 * @param {Object} coupon
 */
export function getPartnerCouponPrice(coupon) {
  const { discountAmount, minBuyAmount, maxAmount } = coupon;

  // 스킴 노출인 경우 최소 금액 조건으로 표기
  if (checkPartnerRenderSkim(coupon)) {
    return minBuyAmount;
  }

  // 정액 할인가 계산
  if (getCouponType(coupon) === 'AMOUNT') {
    return TMON.util.numberWithComma(
      Number(TMON.htStaticData.discountInfosPrice) - discountAmount
    );
  }

  const percentPrice =
    Number(TMON.htStaticData.discountInfosPrice) *
    (coupon.discountPercent / 100);

  // 정률 할인가 계산
  return TMON.util.numberWithComma(
    percentPrice > maxAmount
      ? Number(TMON.htStaticData.discountInfosPrice) - maxAmount
      : Number(TMON.htStaticData.discountInfosPrice) -
          Math.floor(percentPrice - (percentPrice % 10))
  );
}

/**
 * 쿠폰 타입 반환
 * @param {Object} coupon
 */
export function getCouponType(coupon) {
  return coupon.couponType;
}

/**
 * 파트너 부담 쿠폰 최소 금액 조건 부합 여부
 * @param {Object} coupon
 */
export function checkPartnerCouponMinAmount(coupon) {
  const { minBuyAmount } = coupon;
  return TMON.htStaticData.discountInfosPrice >= minBuyAmount;
}
